import { ChatBubble } from './chat-bubble';
import { ChatDayDivider } from './chat-day-divider';
import { ChatMessageAction } from './chat-message-action';

/**
 * `Chat` — a compound for a conversation thread.
 *
 * Purely presentational: the app owns the messages, realtime transport, and all
 * copy. Compose a thread from day dividers and left/right bubbles:
 *
 * ```tsx
 * <div className="flex flex-col gap-3">
 *   <Chat.DayDivider>Сегодня, 20 июня</Chat.DayDivider>
 *   <Chat.Bubble side="inbound" avatar={<Avatar>…</Avatar>}>
 *     Здравствуйте, я прибыл по месту назначения…
 *   </Chat.Bubble>
 *   <Chat.Bubble
 *     side="outbound"
 *     actions={
 *       <>
 *         <Chat.MessageAction label="Ответить" onClick={reply}>
 *           <ReplyIcon />
 *         </Chat.MessageAction>
 *         <Chat.MessageAction label="Удалить" destructive onClick={remove}>
 *           <TrashIcon />
 *         </Chat.MessageAction>
 *       </>
 *     }
 *   >
 *     Сейчас проверим
 *   </Chat.Bubble>
 * </div>
 * ```
 */
export const Chat = {
  Bubble: ChatBubble,
  DayDivider: ChatDayDivider,
  MessageAction: ChatMessageAction,
};

export { chatBubbleVariants } from './chat-bubble';
export type { ChatBubbleProps } from './chat-bubble';
export type { ChatDayDividerProps } from './chat-day-divider';
export type { ChatMessageActionProps } from './chat-message-action';
